import React from 'react'
import Grid from '@material-ui/core/Grid'
import getUrl from 'front-end-core/core/url'
import Icon from 'components/shared/Icon'
import ArrowLink from 'components/redesign/ArrowLink'
import { LEGISLATION_MENU } from 'constants/controllers'
import cx from 'classnames'

const LegFoldersHeader = ({ aol, isProxy = false }) => (
  <div className={cx('pt9 layout-width-constraint', { wait: isProxy })}>
    <Grid container>
      <Grid item className='pr4'>
        <Icon name='icon-legislation' className='w7' />
      </Grid>
      <Grid item className='f5 dark-orchid pr6'>
        Legislation
      </Grid>
      <Grid item>
        <ArrowLink
          text='View all'
          textCx='pr4'
          url={isProxy ? null : getUrl(LEGISLATION_MENU, { aol })}
        />
      </Grid>
    </Grid>
  </div>
)

export default LegFoldersHeader
